<div class="flex justify-between">
  <rk-page-title [title]="'SCHEDULE.PLANNING.TITLE' | translate"></rk-page-title>
  <rk-button
    class="block md:hidden"
    [label]="(currentDay$ | async)?.format('MMMM YYYY')"
    [btnStyle]="'flat'"
    (click)="selectDate()"
  ></rk-button>
</div>
<div class="text-gray-darkest -mt-3 mb-2 hidden md:block" translate>
  SCHEDULE.PLANNING.HINT
</div>

<div class="planning-header--actions hidden md:flex">
  <rk-button
    data-cy="planning-add-slot"
    [label]="'SCHEDULE.PLANNING.ADD_SLOT' | translate"
    [disabled]="!((hasPrograms$ | async) || (hasPlaylists$ | async))"
    rkTooltip
    [tooltipDescription]="'SCHEDULE.PLANNING.NO_PROGRAM_PLAYLIST' | translate"
    [tooltipDisabled]="(hasPrograms$ | async) || (hasPlaylists$ | async)"
    tooltipPosition="bottom"
    faIcon="fa-plus"
    (click)="addSlotClicked()"
  ></rk-button>
  <rk-animated-arrow
    *ngIf="pulse"
    [description]="'CHECKLIST.ARROW.PLANNING_DESCRIPTION' | translate"
  ></rk-animated-arrow>
  <rk-date-select
    class="planning-header--actions-datepicker"
    [calendarDatesChanged]="calendarDatesChanged"
    (dateSelectDatesChanged)="dateSelectDatesUpdated($event)"
  ></rk-date-select>
  <rk-button
    class="planning-header--actions-previous"
    btnStyle="flat"
    faIcon="fa-angle-left"
    [squarePadding]="true"
    (click)="calendarPreviousClicked()"
  ></rk-button>
  <rk-button
    class="planning-header--actions-next"
    btnStyle="flat"
    faIcon="fa-angle-right"
    [squarePadding]="true"
    (click)="calendarNextClicked()"
  ></rk-button>
  <rk-button
    class="planning-header--actions-now"
    [label]="'SCHEDULE.PLANNING.NOW' | translate"
    btnStyle="flat"
    (click)="calendarTodayClicked()"
  ></rk-button>
  <rk-button
    class="ml-auto"
    btnStyle="flat"
    faIcon="fa-list"
    [disabled]="!((hasPrograms$ | async) || (hasPlaylists$ | async))"
    rkTooltip
    [tooltipDescription]="
      !((hasPrograms$ | async) || (hasPlaylists$ | async))
        ? ('SCHEDULE.PLANNING.NO_PROGRAM_PLAYLIST' | translate)
        : ('SCHEDULE.PLANNING.PROGRAM_PLAYLIST_HERE' | translate)
    "
    [customStyle]="{ width: '250px' }"
    tooltipPosition="bottom"
    arrowPosition="right"
    (click)="addSlotPanel()"
  >
  </rk-button>
</div>
